export enum ChampsInformationModeEnseignement {
  EchelleNotation,
  CoursEnFrancais,
}
